import React, { useEffect } from 'react'
import Empty from '../feedback/Empty';
import Pagination from '../nav/Pagination';
import ProductRow from './ProductRow';

function ProductsTable(props) {
    const products = props.products

    useEffect(() => { }, [products])
    return (
        <div className='p-3 bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark'>
            <div className='overflow-x-hidden'>
                <table className="table table-compact table-zebra w-full">
                    <thead>
                        <tr>
                            <th className='hidden md:table-cell'>Image</th>
                            <th>Product</th>
                            <th className='hidden md:table-cell'>Brand</th>
                            <th className='hidden md:table-cell'>Price</th>
                            <th>Quantity</th>
                            <th className='hidden md:table-cell'>Purchases</th>
                            <th className='hidden md:table-cell'>Created</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products?.results?.map((product, idx) => (
                            <ProductRow
                                openModal={props.openModal}
                                key={idx}
                                product={product}
                            />
                        ))}
                    </tbody>
                </table>
                {products?.count < 1 ? (
                    <Empty objectName={"Products"} />
                ) : null}
                {products?.count ? (
                    <div className='mt-8 flex justify-center'>
                        <Pagination
                            count={products?.count}
                            next={products?.next}
                            previous={products?.previous}
                            changePageParam={props.changePageParam}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default ProductsTable